import { TasksAndCountModel } from "@teamprevent/common/task/taskActions/models";
import { MessageAction } from "@teamprevent/common/messaging/actions";
import * as messageActions from "@teamprevent/common/messaging/actionTypes";

import { ActionableTaskAction } from "./actions";
import * as actions from "./actionTypes";

export function actionableTasks(state: TasksAndCountModel = { tasks: [], totalCount: 0 }, action: ActionableTaskAction | MessageAction): TasksAndCountModel {
    switch (action.type) {
        case actions.LOAD_ACTIONABLE_TASKS_SUCCESS:
            return action.payload;
        case actions.ASSIGN_USERS_SUCCESS:
            return {
                ...state,
                tasks: [...state.tasks].map(task => {
                    const updatedTask = action.payload.tasks.find(t => t.id === task.id);
                    if (updatedTask) {
                        return Object.assign({}, task, { selected: false, assignedUsers: action.payload.users });
                    }
                    return task;
                })
            };
        case messageActions.COMPLETE_ACTIONABLE_TASK_SUCCESS:
            return {
                tasks: state.tasks.filter(task => task.id !== action.payload.id),
                totalCount: state.totalCount - 1
            };
        default:
            return state;
    }
}
